module.exports = __webpack_public_path__ + "img/wral-grey.cc2a96c.svg";